<template>
    <div>

      <el-form size="small" ref="form" :model="formData" label-width="180px"  :inline="true" :rules="rules">
        <el-form-item label="项目管理员" prop="manager_users">
            <el-select   placeholder="请选择" :multiple="true" v-model="formData.manager_users">
              <el-option
                  v-for="item in userList"
                  :key="item.user_app_id"
                  :label="item.nickname"
                  :value="item.user_app_id">
              </el-option>
            </el-select>
        </el-form-item>
  
        <el-form-item>
          <el-button type="primary" size="small"  @click="setManager">保存</el-button>
        </el-form-item>
      </el-form>


      <el-form size="small" ref="form2" :model="formData" label-width="180px"  :inline="true" :rules="rules">
       
        <el-form-item label="监察人员" prop="supervisor_users">
            <el-select  placeholder="请选择" :multiple="true"  v-model="formData.supervisor_users">
            <el-option
                v-for="item in userList"
                :key="item.user_app_id"
                :label="item.nickname"
                :value="item.user_app_id"> 
            </el-option>
            </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" size="small"  @click="setSupervisor">保存</el-button>
        </el-form-item>
      </el-form>


    </div>
  </template>
  <script>
  import ImageUpload from '@/components/ImageUpload';
  import urlConfig from '@/api/config'
  import { getTalent,postPurview,getPurview} from "@/api/common/index.js";


  
  export default {
    components: {
      ImageUpload
    },
  

  
    data () {
      return {
        uploadFileUrl:  urlConfig.prod.baseURL +"/web/file/Upload", // 上传的图片服务器地址
        project_id:"",
        formData:  {
          manager_users:[],
          supervisor_users:[],
        },
        userList:[],
        rules: {
          manager_users: [
            { required: true, message: '请选择管理员', trigger: 'change' }
          ],
          supervisor_users: [
            { required: true, message: '请选择项目监管', trigger: 'blur' }
          ],
        
        }
  
      }
    },
  
    created(){

     
    },
    mounted () {
      if(this.$route.query&&this.$route.query.project_id){
        this.project_id=this.$route.query.project_id;
      }
     this.initUserList();
     this.getUsers(3);
     this.getUsers(4);
     
    },
    methods:{


      initUserList(){
        var that = this;
        getTalent({"type":2,"user_type":2}).then((response) => {
          console.log(response);
          if(response.code==200){
            that.userList=response.data;
          }else{
            that.$message.error(response.msg?response.msg:"请求错误");
          }
         
        });
      },


 

      //3 项目管理 4 督查
      getUsers(type){
        var that=this;
        var params={
          type:type,//项目管理
          purview_field:'projec_id',
          field_value:this.project_id,
        };
        
         // postPurview
            getPurview(params).then((response) => {
                console.log(response);
                if(response.code==200){
                  if(type==3){

                    response.data.forEach((item) => {
                      this.formData.manager_users.push(item.user_app_id)
                    });
                    
                  } 

                  if(type==4){

                    response.data.forEach((item) => {
                      this.formData.supervisor_users.push(item.user_app_id)
                    });

                  }
                }else{
                  this.$message({
                    message: response.msg?response.msg:"获取信息失败",
                  });
                }
              });
              
      },


        //设置项目管理
      setManager(){
        var that=this;
        var params={
          user_app_ids:that.formData.manager_users.join(","),
          type:3,//项目管理
          purview_field:'projec_id',
          field_value:this.project_id,
        };
        
         // postPurview
        this.$refs["form"].validate((valid) => {
            if (valid) {
              postPurview(params).then((response) => {
                  console.log(response);
                  if(response.code==200){
                    this.$message({
                      message: "提交成功",
                      type: 'success'

                    });
                  }else{
                    this.$message({
                      message: response.msg?response.msg:"提交失败",
                    });
                  }
                });
              
            } 
          });
      },

        //设置督查
      setSupervisor(){
        var that=this;
        var params={
          user_app_ids:that.formData.supervisor_users.join(","),
          type:4,//项目管理
          purview_field:'projec_id',
          field_value:this.project_id,
        };
        
         // postPurview
        this.$refs["form"].validate((valid) => {
            if (valid) {
              postPurview(params).then((response) => {
                  console.log(response);
                  if(response.code==200){
                    this.$message({
                      message: "提交成功",
                      type: 'success'

                    });
                  }else{
                    this.$message({
                      message: response.msg?response.msg:"提交失败",
                    });
                  }
                });
              
            } 
          });
      }
  
    }
  }
  </script>
  
  
  <style lang="scss" scoped>

  </style>